"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTickColor = exports.getRingColor = exports.getRadioBorderColor = exports.getIndeterminateBarColor = exports.getHoverColor = exports.getFocusColor = exports.getDetailedBoxTextColor = exports.getCheckedTextColor = exports.getCheckedBorderColor = exports.getCheckedBackgroundColor = exports.getBorderColor = exports.getBackgroundColor = exports.getActiveBorderColor = exports.buildLabelId = void 0;

var _constants = require("./constants");

var buildLabelId = function buildLabelId(id) {
  return "".concat(id, "-label");
};

exports.buildLabelId = buildLabelId;

var getDisabledBackgroundColor = function getDisabledBackgroundColor(isInverted) {
  return isInverted ? _constants.DISABLED_COLOR : _constants.DISABLED_BACKGROUND_COLOR;
};

var getDisabledColor = function getDisabledColor(isInverted) {
  return getDisabledBackgroundColor(!isInverted);
};

var getBackgroundColor = function getBackgroundColor(_ref) {
  var disabled = _ref.disabled,
      getColor = _ref.getColor,
      isInverted = _ref.isInverted;

  if (disabled) {
    return getColor(getDisabledBackgroundColor(isInverted));
  }

  return getColor(isInverted ? 'transparent' : _constants.DEFAULT_BACKGROUND_COLOR);
};

exports.getBackgroundColor = getBackgroundColor;

var getBorderColor = function getBorderColor(_ref2) {
  var disabled = _ref2.disabled,
      error = _ref2.error,
      getColor = _ref2.getColor,
      isInverted = _ref2.isInverted;

  if (disabled) {
    return getColor(getDisabledColor(isInverted));
  }

  if (isInverted) {
    return getColor(error ? _constants.ERROR_INVERTED_DEFAULT_COLOR : _constants.BORDER_INVERTED_COLOR);
  }

  return getColor(error ? _constants.ERROR_DEFAULT_COLOR : _constants.BORDER_COLOR);
};

exports.getBorderColor = getBorderColor;

var getRadioBorderColor = function getRadioBorderColor(_ref3) {
  var disabled = _ref3.disabled,
      getColor = _ref3.getColor,
      isInverted = _ref3.isInverted;

  if (disabled) {
    return getColor(getDisabledColor(isInverted));
  }

  if (isInverted) {
    return getColor(_constants.BORDER_INVERTED_COLOR);
  }

  return getColor(_constants.BORDER_COLOR);
};

exports.getRadioBorderColor = getRadioBorderColor;

var getDetailedBoxTextColor = function getDetailedBoxTextColor(_ref4) {
  var disabled = _ref4.disabled,
      getColor = _ref4.getColor,
      isInverted = _ref4.isInverted;

  if (disabled) {
    return getColor(getDisabledColor(isInverted));
  }

  return getColor(isInverted ? _constants.DEFAULT_INVERTED_TEXT_COLOR : _constants.DEFAULT_TEXT_COLOR);
};

exports.getDetailedBoxTextColor = getDetailedBoxTextColor;

var getCheckedBorderColor = function getCheckedBorderColor(_ref5) {
  var disabled = _ref5.disabled,
      error = _ref5.error,
      getColor = _ref5.getColor,
      isInverted = _ref5.isInverted;

  if (disabled) {
    return getColor(getDisabledColor(isInverted));
  }

  if (isInverted) {
    return getColor(error ? _constants.ERROR_INVERTED_DEFAULT_COLOR : _constants.DEFAULT_INVERTED_COLOR);
  }

  return getColor(error ? _constants.ERROR_DEFAULT_COLOR : _constants.DEFAULT_COLOR);
};

exports.getCheckedBorderColor = getCheckedBorderColor;

var getCheckedBackgroundColor = function getCheckedBackgroundColor(_ref6) {
  var disabled = _ref6.disabled,
      error = _ref6.error,
      getColor = _ref6.getColor,
      isInverted = _ref6.isInverted;

  if (disabled) {
    return getColor(getDisabledBackgroundColor(isInverted));
  }

  return getCheckedBorderColor({
    error: error,
    getColor: getColor,
    isInverted: isInverted
  });
};

exports.getCheckedBackgroundColor = getCheckedBackgroundColor;

var getCheckedTextColor = function getCheckedTextColor(_ref7) {
  var disabled = _ref7.disabled,
      getColor = _ref7.getColor,
      isInverted = _ref7.isInverted;

  if (disabled) {
    return getColor(getDisabledBackgroundColor(isInverted));
  }

  return getColor(isInverted ? _constants.DEFAULT_TEXT_COLOR : _constants.DEFAULT_INVERTED_TEXT_COLOR);
};

exports.getCheckedTextColor = getCheckedTextColor;

var getIndeterminateBarColor = function getIndeterminateBarColor(_ref8) {
  var disabled = _ref8.disabled,
      error = _ref8.error,
      getColor = _ref8.getColor,
      isInverted = _ref8.isInverted;

  if (disabled) {
    return getColor(getDisabledColor(isInverted));
  }

  if (isInverted) {
    return getColor(error ? _constants.ERROR_INVERTED_DEFAULT_COLOR : _constants.DEFAULT_INVERTED_COLOR);
  }

  return getColor(error ? _constants.ERROR_DEFAULT_COLOR : _constants.DEFAULT_COLOR);
};

exports.getIndeterminateBarColor = getIndeterminateBarColor;

var getHoverColor = function getHoverColor(_ref9) {
  var error = _ref9.error,
      getColor = _ref9.getColor,
      isInverted = _ref9.isInverted;

  if (isInverted) {
    return getColor(error ? _constants.ERROR_INVERTED_HOVER_COLOR : _constants.HOVER_INVERTED_COLOR);
  }

  return getColor(error ? _constants.ERROR_HOVER_COLOR : _constants.HOVER_COLOR);
};

exports.getHoverColor = getHoverColor;

var getActiveBorderColor = function getActiveBorderColor(_ref10) {
  var disabled = _ref10.disabled,
      error = _ref10.error,
      getColor = _ref10.getColor,
      isInverted = _ref10.isInverted;

  if (disabled) {
    return getColor(getDisabledColor(isInverted));
  }

  if (isInverted) {
    return getColor(error ? _constants.ERROR_INVERTED_HOVER_COLOR : _constants.HOVER_INVERTED_COLOR);
  }

  return getColor(error ? _constants.ERROR_HOVER_COLOR : _constants.HOVER_COLOR);
};

exports.getActiveBorderColor = getActiveBorderColor;

var getFocusColor = function getFocusColor(_ref11) {
  var error = _ref11.error,
      getColor = _ref11.getColor,
      isInverted = _ref11.isInverted;

  if (isInverted) {
    return getColor(error ? _constants.ERROR_INVERTED_FOCUS_COLOR : _constants.FOCUS_INVERTED_COLOR);
  }

  return getColor(error ? _constants.ERROR_FOCUS_COLOR : _constants.FOCUS_COLOR);
};

exports.getFocusColor = getFocusColor;

var getRingColor = function getRingColor(_ref12) {
  var disabled = _ref12.disabled,
      getColor = _ref12.getColor,
      isInverted = _ref12.isInverted;

  if (disabled) {
    return getColor(getDisabledBackgroundColor(isInverted));
  }

  return getColor(isInverted ? _constants.DEFAULT_TEXT_COLOR : _constants.DEFAULT_INVERTED_TEXT_COLOR);
};

exports.getRingColor = getRingColor;

var getTickColor = function getTickColor(_ref13) {
  var disabled = _ref13.disabled,
      getColor = _ref13.getColor,
      isInverted = _ref13.isInverted;

  if (disabled) {
    return getColor(getDisabledColor(isInverted));
  }

  return getColor(isInverted ? _constants.DEFAULT_TEXT_COLOR : _constants.DEFAULT_INVERTED_TEXT_COLOR);
};

exports.getTickColor = getTickColor;